import { render } from "./VaPageNotFoundLargeText.vue?vue&type=template&id=e59862a6"
import script from "./VaPageNotFoundLargeText.vue?vue&type=script&lang=js"
export * from "./VaPageNotFoundLargeText.vue?vue&type=script&lang=js"

import "./VaPageNotFoundLargeText.vue?vue&type=style&index=0&id=e59862a6&lang=scss"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__